import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, ClipboardList, Wallet, FileText, HelpingHand, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";
import LangToggle from "@/components/LangToggle";

const links = [
  { to: "/agent", icon: LayoutDashboard, label: "Dashboard", end: true, testId: "agent-nav-dashboard" },
  { to: "/agent/customers", icon: Users, label: "My Customers", testId: "agent-nav-customers" },
  { to: "/agent/policies", icon: FileText, label: "Policies", testId: "agent-nav-policies" },
  { to: "/agent/collections", icon: ClipboardList, label: "Collections", testId: "agent-nav-collections" },
  { to: "/agent/finance-support", icon: HelpingHand, label: "Finance Support", testId: "agent-nav-finance" },
  { to: "/agent/earnings", icon: Wallet, label: "Earnings", testId: "agent-nav-earnings" },
];

export default function AgentLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = () => { logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="agent-layout">
      <header className="bg-tenant-gradient text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl gold-grad grid place-items-center text-tenant-primary font-extrabold">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <div className="font-extrabold tracking-tight">Agent Portal</div>
              <div className="text-[11px] opacity-80">{user?.full_name}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <LangToggle />
            <button data-testid="agent-logout" onClick={onLogout} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/15 hover:bg-white/25 text-[11px] font-bold uppercase tracking-wider">
              <LogOut className="w-3.5 h-3.5" /> Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-2 sm:px-6 pt-3">
        <nav className="flex gap-1 overflow-x-auto scrollbar-hide bg-white rounded-2xl p-1.5 card-shadow border border-slate-100">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `flex-1 min-w-[120px] inline-flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-xs font-bold whitespace-nowrap tap-scale ${
                  isActive ? "bg-tenant-primary text-white shadow-md" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 page-enter">
        <Outlet />
      </main>
    </div>
  );
}
